export const categories = [
  {
    name: "Featured",
    description: (
      <span>
        Some of the most outstanding project covering some advance concepts of{" "}
        <span className="font-semibold text-cyan-400">React.js 18</span> and{" "}
        <span className="font-semibold text-cyan-400">Next.js 14</span>.
      </span>
    ),
  },
  {
    name: "React",
    description: (
      <span>
        Discover the projects built with{" "}
        <span className="font-semibold text-cyan-400">React.js 18</span> and
        many libraries which includes React Router Dom, React Hook Form, React
        Icons, React Scroll etc. Beisdes, covers all the concepts from basic to
        advanced that are used in developing react app like Context API,
        Reducer, Hooks like useMemo(), useDebugValue(), useTransition() and many
        more, data fetching using fetch API and Axios from backend or third
        party API, loading and error handling in React, Authorization(login,
        signup, JWT authentication), use of suspense and lazy loading to
        increase performance, Infinite Scroll, React Portal, React Virtualized.
      </span>
    ),
  },
  {
    name: "Next.js",
    description: (
      <span>
        Projects that I made with Next.js 14 and some basic to advance concept.
        Concept like CSR, SSR, Server and Client component, Dynamic and Parallel
        Routing, Next.js Hooks, Streaming, Intercepting
        routes,Internationalization, Sequential and Parallel data fetching,
        diffeent types of Caching, API development using Next.js, data fetching
        on server and client, different use cases of Server Action, handling
        metadata for SEO optimization, Lazy loading and React Suspense, Next
        Auth for Authorization.
      </span>
    ),
  },
  { name: "Tailwind CSS", description: "Projects that are designed with Tailwind CSS." },
  { name: "Material UI", description: "Some of the projects built with Material UI and its amazing reusable components, icons." },
  {
    name: "Framer Motion",
    description: "Projects animated using Framer Motion",
  },
  { name: "All Projects", description: "All projects" },
];

export const miniCategories = [
  {
    name: "Featured",
    description:
      "Some of the most outstanding project covering some advance concepts of React.js18 and Next.js14.",
  },
  { name: "React", description: "Projects built with React" },
  { name: "Next.js", description: "Projects built with Next.js" },
  { name: "All Projects", description: "All projects" },
];
